module.exports = __webpack_public_path__ + "static/media/5-focus.a66bc55e.svg";